<script>
import { isEmpty } from 'lodash';

export default {
  name: 'nx-seo-base-field',
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    draft: {
      get() {
        return this.value.value;
      },
      set(value) {
        this.$emit('input', this.name, value);
      },
    },
    effectiveValue() {
      if (isEmpty(this.value.effectiveValue)) {
        return '';
      }
      if (Array.isArray(this.value.effectiveValue)) {
        return `${this.$t('message.common.preview')}: ${this.value.effectiveValue.join(', ')}`;
      }
      return `${this.$t('message.common.preview')}: ${this.value.effectiveValue}`;
    },
    inheritedValue() {
      return this.value.inheritedValue || null;
    },
    placeholder() {
      if (!this.inheritedValue) {
        return null;
      }
      return this.inheritedValue.value;
    },
    origin() {
      if (!this.inheritedValue) {
        return null;
      }
      return this.value.inheritedValue.origin;
    },
  },
};
</script>
